import { useState } from "react";
import * as React from "react";
import { Box, Tab, Chip, Typography } from "@mui/material";
import { TabPanel, TabContext, TabList } from "@mui/lab";
import PageTitle from "../PageTitle";
import Loader from "../../common/Loader";
import TicketList from "./TicketList";
import { useEffect } from "react";
import { getGeneric } from "../../common/constants";
import { apiConstants } from "../../common/constants";
import { useSnackbar } from "notistack";
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

const EscalationManagement = ({ reload }) => {
    const [value, setValue] = React.useState("1");
    const [openCount, setOpenCount] = useState(0);
    const [closeCount, setCloseCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [statusList, setStatusList] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const handleChange = (_event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        const fetchStatusList = async () => {
            try {
                const response = await getGeneric(`${apiConstants.GET_FRESHDESK_STATUS_LIST}`);
                if (response?.data?.status !== 'ERROR') {
                    const list = JSON.parse(response?.data?.responseObj);
                    setStatusList(list?.choices);
                } else {
                    setStatusList([]);
                    enqueueSnackbar("Some error occurred in fetching status list!", { variant: "error" });
                }
            } catch (error) {
                enqueueSnackbar("Some error occurred in fetching status list!", { variant: "error" });
                console.error(error);
            }
        }
        fetchStatusList()
    }, [])

    return (
        <>
            <PageTitle>Escalation Management System</PageTitle>
            {isLoading && <Loader />}

            {/* ── Header ── */}
            <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box sx={{
                    width: 48, height: 48, borderRadius: 2.5, flexShrink: 0,
                    background: 'linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    boxShadow: '0 4px 14px rgba(21,101,192,0.25)',
                }}>
                    <SupportAgentIcon sx={{ color: '#fff', fontSize: 26 }} />
                </Box>
                <Box>
                    <Typography variant="h6" fontWeight={700} color="text.primary" sx={{ lineHeight: 1.3 }}>
                        Escalation Management
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Track, manage and resolve support tickets efficiently
                    </Typography>
                </Box>
            </Box>

            {/* ── Tabs ── */}
            <TabContext value={value}>
                <Box sx={{
                    backgroundColor: '#fff', borderRadius: 3,
                    border: '1px solid #e0e0e0', overflow: 'hidden',
                }}>
                    <TabList
                        onChange={handleChange}
                        sx={{
                            minHeight: 52, px: 1,
                            '& .MuiTabs-indicator': {
                                height: 3, borderRadius: '3px 3px 0 0',
                                backgroundColor: '#1565c0',
                            },
                            '& .MuiTab-root': {
                                minHeight: 52, px: 3,
                                fontWeight: 600, fontSize: '0.85rem',
                                textTransform: 'none', color: '#919EAB',
                                transition: 'color 0.2s',
                                '&:hover': { color: '#212B36' },
                                '&.Mui-selected': { color: '#1565c0' },
                            },
                        }}
                    >
                        <Tab
                            label={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    Open Tickets
                                    {openCount > 0 && (
                                        <Chip
                                            label={openCount > 9999 ? '9999+' : openCount}
                                            size="small"
                                            sx={{
                                                height: 22, minWidth: 32,
                                                fontSize: '0.7rem', fontWeight: 700,
                                                backgroundColor: '#fff3e0', color: '#e65100',
                                                border: '1px solid #ffe0b2',
                                                '& .MuiChip-label': { px: 1 },
                                            }}
                                        />
                                    )}
                                </Box>
                            }
                            value="1"
                        />
                        <Tab
                            label={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    Closed Tickets
                                    {closeCount > 0 && (
                                        <Chip
                                            label={closeCount > 9999 ? '9999+' : closeCount}
                                            size="small"
                                            sx={{
                                                height: 22, minWidth: 32,
                                                fontSize: '0.7rem', fontWeight: 700,
                                                backgroundColor: '#e8f5e9', color: '#2e7d32',
                                                border: '1px solid #c8e6c9',
                                                '& .MuiChip-label': { px: 1 },
                                            }}
                                        />
                                    )}
                                </Box>
                            }
                            value="2"
                        />
                    </TabList>
                </Box>

                <TabPanel value="1" sx={{ px: 0, pt: 2.5 }}>
                    <TicketList status={'open'} isLoading={isLoading} setIsLoading={setIsLoading} setOpenCount={setOpenCount} statusList={statusList} />
                </TabPanel>
                <TabPanel value="2" sx={{ px: 0, pt: 2.5 }}>
                    <TicketList status={'closed'} isLoading={isLoading} setIsLoading={setIsLoading} setCloseCount={setCloseCount} statusList={statusList} />
                </TabPanel>
            </TabContext>
        </>
    )
}

export default EscalationManagement
